import { render, staticRenderFns } from "./AcceptTerms.vue?vue&type=template&id=475bb642&scoped=true"
import script from "./AcceptTerms.vue?vue&type=script&lang=js"
export * from "./AcceptTerms.vue?vue&type=script&lang=js"
import style0 from "./AcceptTerms.vue?vue&type=style&index=0&id=475bb642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475bb642",
  null
  
)

export default component.exports